import { render, staticRenderFns } from "./EmailMessageEditor.vue?vue&type=template&id=1fded770&lang=pug"
import script from "./EmailMessageEditor.vue?vue&type=script&lang=js"
export * from "./EmailMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageEditor.vue?vue&type=style&index=0&id=1fded770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports